import { getLevelUpCompetencyDataApi, setAgendaFromLevelUpPageApi, getLevelUpReporteeDataApi } from '../api';

export const getLevelUpCompetencyData = ({ employeeId, targetRole = false }) =>
  getLevelUpCompetencyDataApi({ employeeId, targetRole }).then((res) => res.entity);

export const setAgendaFromLevelUpPage = ({ status, text, uiKey, employeeId }) =>
  setAgendaFromLevelUpPageApi({ status, text, uiKey, employeeId }).then((res) => res.entity);

export const getLevelUpReporteeData = ({ employeeId }) =>
  getLevelUpReporteeDataApi({ employeeId }).then((res) => res.entity);
